import styled, { createGlobalStyle } from 'styled-components'
import { Row, Select } from 'antd'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import {
  MID_BREAKPOINT,
  SMALL_BREAKPOINT,
  XSMALL_BREAKPOINT,
  XXSMALL_BREAKPOINT,
} from './../../../style'

export const PageTitle = styled.h2`
  color: ${colors.black1};
  font-weight: 900;
  font-size: 1.5rem;
  line-height: 2.125rem;
  margin-bottom: 1rem;

  @media all and (max-width: ${MID_BREAKPOINT}) {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`
export const WhiteBox = styled.div`
  background: white;
  border: 1px solid ${colors.gandalf};
  box-sizing: border-box;
  border-radius: 0.75rem;
  padding: 1.5rem 2.25rem;
  margin-bottom: 2.25rem;
  color: ${colors.black1};

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    padding: 1rem;
  }
`
export const BrandInfo = styled.div`
  display: flex;
  margin-bottom: 1.25rem;
`
export const Info = styled.div`
  max-width: 26rem;

  input {
    display: none;
  }

  h3 {
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1.5rem;
  }

  p {
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.dawn};
    margin-bottom: 0.625rem;
  }

  a {
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.125rem;
    color: ${colors.adaptBlue} !important; /* stylelint-disable-line */
  }
`
export const LogoWrapper = styled.div`
  filter: drop-shadow(0 2px 48px rgba(0, 0, 0, 0.1));
  width: 5.625rem;
  height: 5.625rem;
  min-width: 5.625rem;
  margin-right: 1.25rem;
  border-radius: 50%;
  padding: 1rem;
  background: white;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: -0.5rem;
    right: -0.5rem;
    top: -0.5rem;
    bottom: -0.5rem;
    border: 1.5px dashed ${colors.gandalf};
    border-radius: 50%;
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    width: 2.25rem;
    height: 2.25rem;
    min-width: 2.25rem;
    padding: 0;
  }
`
export const Input = styled.input<{ error?: boolean }>`
  border: 1px solid ${colors.radagast};
  height: 2.75rem;
  color: ${colors.black1};
  font-size: 0.875rem;
  border-radius: 6px;
  width: 100%;
  padding: 0 1rem;
  transition: all 0.3s ease;

  &:invalid + .error-wrapper {
    display: block;
  }

  &.filled {
    border-color: ${colors.gandalf};
    background: ${colors.gandalf};
  }

  &:focus {
    border-color: ${colors.black1};
    background: ${colors.white};
  }

  && {
    ${({ error }) =>
      error &&
      `
      border: 1px solid ${colors.alert};
      background: ${colors.white};
    `};
  }
`
export const InputLabel = styled.h4`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.5rem;
  color: ${colors.black1};
  text-transform: none;
  margin-bottom: 0.375rem;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${colors.saruman};
    opacity: 1; /* Firefox */
  }

  /* stylelint-disable */
  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${colors.saruman};
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${colors.saruman};
  }
  /* stylelint-enable */
`
export const TextArea = styled.textarea`
  border: 1px solid ${colors.radagast};
  color: ${colors.black1};
  font-size: 0.875rem;
  border-radius: 6px;
  width: 100%;
  padding: 0.75rem 1rem;
  height: 9rem;

  &.filled {
    border-color: ${colors.gandalf};
    background: ${colors.gandalf};
  }
`
export const HtmlSelect = styled.select`
  border: 1px solid ${colors.radagast};
  height: 2.75rem;
  color: ${colors.black1};
  font-size: 0.875rem;
  border-radius: 6px;
  width: 100%;
  padding: 0 1rem;
  background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg)
    no-repeat 98% center;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${colors.saruman};
    opacity: 1; /* Firefox */
  }

  /* stylelint-disable */
  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${colors.saruman};
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${colors.saruman};
  }
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  /* stylelint-enable */
`
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    margin-top: 0.5rem;
  }
`
export const FooterLink = styled.a`
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.375rem;
  color: ${colors.adaptBlue};

  &:hover {
    /* stylelint-disable */
    color: ${colors.adaptBlue} !important;
    /* stylelint-enable */
  }
`
export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-wrap: wrap;
  padding-top: 1rem;
  margin-bottom: -0.5rem;

  > div {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
`
export const BrandSettinsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 2.25rem;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    padding-top: 2.25rem;
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    flex-direction: column;
    align-items: center;
    padding-bottom: 1.5rem;

    div:first-child {
      margin-bottom: 0.5rem;
      width: 100%;

      > div {
        width: 50%;
      }
    }
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    button {
      width: 100%;
    }
  }

  div > button {
    margin-bottom: 0.375rem;
  }
  div > button:first-child {
    margin-right: 0.75rem;
  }
`
export const StyledRow = styled(Row as any)`
  margin-bottom: 1.25rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: block;
    margin-bottom: 0;
  }

  > div {
    @media all and (max-width: ${XSMALL_BREAKPOINT}) {
      margin-bottom: 1rem;
    }
  }
`
export const StyledSelect = styled(Select as any)<{ error?: boolean }>`
  &&& {
    width: 100%;
  }
  .ant-select-dropdown-menu-item:hover {
    && {
      background: ${colors.adaptBlue};
      color: white;
    }
  }
  .ant-select-selection__placeholder.ant-select-selection__placeholder {
    color: ${colors.nebula};
  }
  .ant-select-selection.ant-select-selection.ant-select-selection {
    border: 1px solid ${({ error }) => (error ? colors.alert : colors.radagast)};
    height: 2.75rem;
    color: ${colors.black1};
    font-size: 0.875rem;
    border-radius: 6px;
    width: 100%;
    padding: 0 1rem;

    .ant-select-selection__rendered {
      margin: 0;
      color: ${colors.black1};
      height: 2.75rem;
      display: flex;
      align-items: center;
    }
  }

  &.filled .ant-select-selection.ant-select-selection.ant-select-selection {
    border-color: ${colors.gandalf};
    background: ${colors.gandalf};
  }
  &&&.ant-select-open .ant-select-selection,
  &&&.ant-select-focused .ant-select-selection,
  &&& .ant-select-selection:focus,
  &&& .ant-select-selection:active {
    box-shadow: none;
    border-color: ${colors.black1};
    background: ${colors.white};
    color: ${colors.black1};
  }

  &&&.tagsSelect {
    margin-bottom: 2rem;

    .ant-select-selection__rendered {
      position: absolute;
      bottom: -50px;
      left: 0;
    }
  }

  .ant-select-selection__choice {
    height: 2rem;
    background: ${colors.black1};
    color: white;
    font-size: 0.875rem;
    line-height: 1.5rem;
    padding: 0 2rem 0 0.75rem;
    border-radius: 4.375rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
  }

  &.parent-brand.filled .ant-select-arrow {
    display: none;
  }
`
export const FormError = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: ${colors.alert};
  margin-bottom: 0;
  padding-top: 0.25rem;
`
export const AntdGlobalStyles = createGlobalStyle`
  .ant-select-dropdown-menu-item:hover {
    && {
      background: ${colors.adaptBlue};
      color: white;
    }
  }
`
export const Tag = styled.div`
  height: 2.25rem;
  background: ${colors.black1};
  border-radius: 4.375rem;
  color: white;
  padding: 0 1.875rem 0 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  cursor: pointer;
  position: relative;

  > svg {
    position: absolute;
    right: 0.5rem;
    fill: white;
  }
`
export const ClearElem = styled.div`
  color: ${colors.alert};
  position: absolute;
  z-index: 1;
  right: 1.25rem;
  bottom: 0.75rem;
  cursor: pointer;
`
export const OrdersHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    display: none;
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    margin-bottom: 0.75rem;
  }

  h3 {
    font-weight: 900;
    font-size: 2.25rem;
    line-height: 1;
    color: ${colors.black1};

    @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
      font-size: 1.5rem;
      line-height: 1rem;
    }
  }
`
export const ConciergeFlexBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
`
export const ModalTitle = styled.div`
  font-size: 2rem;
  font-weight: 900;
  line-height: 2.875rem;
  color: ${colors.black1};
  text-align: center;
  margin-bottom: 0.375rem;
`

export const ModalContent = styled.div`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.625rem;
  color: ${colors.black1};
  text-align: center;
`
export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.5rem;
`

export const ErrorMessage = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: ${colors.alert};
  margin-bottom: 0;
  padding-top: 0.25rem;
  text-align: center;
`
export const UL = styled.ul`
  text-align: left;
  list-style: initial;
  padding-left: 24px;
`
export const LI = styled.li`
  list-style: initial;
  display: list-item;
`
export const AlignLeft = styled.div`
  text-align: left;
`
export const MergeAlert = styled.div`
  color: ${colors.alert};
  margin: 1rem 0 0;
  font-weight: 700;
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSettings/BrandDashboardSettings.style.tsx